/**
 * Staff Daily Summary — L-06
 *
 * Route: /staff/today
 * Shows a simple table of today's proxy submissions
 * by the currently-identified staff member.
 * Read-only view.
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const StaffDailySummary = () => {
  const [staffInfo, setStaffInfo] = useState(null);
  const [submissions, setSubmissions] = useState([]);

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem('proxy_staff_info');
      if (stored) setStaffInfo(JSON.parse(stored));

      // Load today's proxy submissions from localStorage log
      const todayKey = new Date().toISOString().slice(0, 10);
      const log = JSON.parse(localStorage.getItem('proxy_submissions_log') || '[]');
      setSubmissions(log.filter(s => s.date?.startsWith(todayKey)));
    } catch { /* no data */ }
  }, []);

  if (!staffInfo) {
    return (
      <div style={{ maxWidth: '600px', margin: '60px auto', textAlign: 'center', padding: '20px' }}>
        <h2 style={{ fontSize: '18px', color: '#374151' }}>Staff Access Required</h2>
        <p style={{ color: '#6b7280', fontSize: '14px' }}>
          Access this page using <code>?proxy=staff</code> mode first.
        </p>
        <Link to="/" style={{ color: 'var(--color-primary, #088395)' }}>&larr; Back to form</Link>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '700px', margin: '40px auto', padding: '20px' }}>
      <Link to="/" style={{ color: 'var(--color-primary, #088395)', fontSize: '14px', textDecoration: 'none' }}>
        &larr; Back
      </Link>

      <h1 style={{ fontSize: '20px', fontWeight: 600, margin: '20px 0 8px', color: '#1a1a2e' }}>
        Today's Submissions
      </h1>
      <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '20px' }}>
        Staff: {staffInfo.role} {staffInfo.name} | {new Date().toLocaleDateString()}
      </p>

      {submissions.length === 0 ? (
        <div style={{
          padding: '30px', textAlign: 'center', background: '#f9fafb',
          borderRadius: '8px', color: '#6b7280', fontSize: '14px'
        }}>
          No proxy submissions recorded today.
          <br/><br/>
          <span style={{ fontSize: '12px' }}>
            Submissions are logged locally when forms are completed in proxy mode.
          </span>
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
          <thead>
            <tr style={{ background: '#f9fafb', textAlign: 'left' }}>
              <th style={{ padding: '10px 12px', borderBottom: '1px solid #e5e7eb' }}>Patient</th>
              <th style={{ padding: '10px 12px', borderBottom: '1px solid #e5e7eb' }}>Time</th>
              <th style={{ padding: '10px 12px', borderBottom: '1px solid #e5e7eb' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {submissions.map((sub, i) => (
              <tr key={i}>
                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f3f4f6' }}>{sub.email || 'N/A'}</td>
                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f3f4f6' }}>{sub.time || 'N/A'}</td>
                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f3f4f6' }}>
                  <span style={{ color: '#16a34a', fontWeight: 500 }}>Submitted</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default StaffDailySummary;
